var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 197.7 239.6",
    style: {
      enableBackground: "new 0 0 197.7 239.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1287FA;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "COMPASS_Icon_RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.8,42C44.3,42,0,86.2,0,140.8s44.3,98.8,98.8,98.8s98.8-44.3,98.8-98.8c0,0,0,0,0,0 C197.7,86.2,153.4,42,98.8,42C98.8,42,98.8,42,98.8,42z M98.8,211.2c-38.9,0-70.4-31.5-70.4-70.4s31.5-70.4,70.4-70.4 s70.4,31.5,70.4,70.4c0,0,0,0,0,0C169.2,179.7,137.7,211.2,98.8,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.7,30l-6-22.3c-0.4-1.6,0.5-3.2,2.1-3.6c0,0,0,0,0,0c22.3-5.4,45.5-5.5,67.8-0.1c1.6,0.4,2.5,2,2.1,3.5 c0,0,0,0,0,0.1l-6,22.3c-0.4,1.5-1.9,2.4-3.4,2c-17.5-4.2-35.7-4.2-53.1,0C70.7,32.3,69.1,31.4,68.7,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.9,161.6l-37.1,10.2l10.3-37c2-7.1,7.6-12.7,14.7-14.7l37-10.3l-10.2,37.1 C117.6,154,112.1,159.6,104.9,161.6z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.c82035e5172126d595ebaa82a2b55160.svg";
export { ForwardRef as ReactComponent };